import axios from "axios";
const domain = "";
export default axios.create({
  domain,
});
